import api from './client';

// Customer-facing chat (auth via session cookie + CSRF handled by client.js)
export const chatSend = (text) => api.post('/chat/messages', { text }).then((r) => r.data);
export const chatMessages = () => api.get('/chat/messages').then((r) => r.data);
export const chatUnread = () => api.get('/chat/unread').then((r) => r.data);
